//styles
import { Pagination } from "react-bootstrap";
import styles from "../../styles/Client.module.css";
//redux
import { useAppDispatch, useAppSelector } from "../../hooks";
import { selectUserData } from "../../redux/reducer/user/userSlice";
import {
    getItemDataAsync,
    selectItemData,
    selectSearchData,
    setPageData,
    selectPageData,
} from "../../redux/reducer/item/itemSlice";

//---------------------------------------------------------

export default function PaginPage() {
    //redux
    const dispatch = useAppDispatch();
    const itemData = useAppSelector(selectItemData);
    const searchData = useAppSelector(selectSearchData);
    const pageData = useAppSelector(selectPageData);
    const { access_token, user } = useAppSelector(selectUserData);

    //hook
    // const [page, setPage] = useState(1);

    //variable
    const rows = 20;
    const pages = Math.ceil(itemData.amount / rows);

    //setPagin
    const setPagin = (direction: number) => {
        const update = pageData + direction;
        const interval = update * rows;
        const data = { ...searchData, id_location: user.id_location, interval };
        dispatch(setPageData(update));
        dispatch(getItemDataAsync({ data, access_token }));
    };

    //view
    return pages > 1 ? (
        <Pagination size="lg" className="mt-0 mb-0" style={{ marginRight: "10px" }}>
            <Pagination.Item>
                <span className={styles.textColor}>{itemData.amount}</span>
            </Pagination.Item>

            {pageData > 0 && (
                <>
                    <Pagination.First
                        onClick={() => {
                            dispatch(setPageData(0));
                            const data = { ...searchData, id_location: user.id_location, interval: 0 };
                            dispatch(getItemDataAsync({ data, access_token }));
                        }}
                    />
                    <Pagination.Prev
                        onClick={() => {
                            setPagin(-1);
                        }}
                    />
                </>
            )}

            {pageData + 1 < pages && (
                <>
                    <Pagination.Next
                        onClick={() => {
                            setPagin(+1);
                        }}
                    />
                    <Pagination.Last
                        onClick={() => {
                            dispatch(setPageData(pages - 1));
                            const data = { ...searchData, id_location: user.id_location, interval: (pages - 1) * 20 };
                            dispatch(getItemDataAsync({ data, access_token }));
                        }}
                    />
                </>
            )}

            <Pagination.Item>
                <span className={styles.textColor}>
                    {pageData + 1}/{pages}
                </span>
            </Pagination.Item>
        </Pagination>
    ) : (
        <></>
    );
}
